import React from "react";
import Paragraph from "../Paragraph";
import pureProps from "../utils/pureProps";
import { sxProps } from "../props/sx";
import { spacingProps } from "../props/spacing";

const MegaMenuTitle = ({ sx = { ...sxProps }, spacing = { ...spacingProps }, ...props }) => {
	return (
		<Paragraph
			sx={{ fontColor: "black--60", fontSize: "s", ...pureProps(sx) }}
			spacing={{ pl: 1, ...pureProps(spacing) }}
			{...props}
		/>
	);
};

MegaMenuTitle.propTypes = {
	...Paragraph.propTypes,
};

export default MegaMenuTitle;
